// extracted by mini-css-extract-plugin
module.exports = {"loadingSkeletonWrapper":"AARvgGmk","title":"cEmilgIQ","errorWrapper":"yAq0jqQo"};